import {
  Box,
  Dialog,
  Icon,
  IconButton,
  Slide,
  Typography,
  useTheme,
} from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import React, { ReactNode } from 'react';
import { useBreakpoint } from '../../hooks';

interface RightSideModalProps {
  title: string;
  children: ReactNode;
  open?: boolean;
  handleClose: () => void;
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="left" ref={ref} {...props} />;
});

export const RightSideModal: React.FC<RightSideModalProps> = ({
  title,
  open = false,
  handleClose,
  children,
}) => {
  const theme = useTheme();

  const breakpoints = useBreakpoint();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      fullScreen={breakpoints.tablet || breakpoints.mobile}
      fullWidth
      maxWidth={'sm'}
      PaperProps={{
        sx: {
          position: 'fixed',
          right: 0,
          top: 0,
          bottom: 0,
          margin: 0,
          height: '100%',
          maxHeight: '100%',
        },
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography paddingLeft={1} paddingTop={1} variant="h6">
          {title}
        </Typography>
        <IconButton size="large" onClick={handleClose}>
          <Icon>close</Icon>
        </IconButton>
      </Box>
      <Box padding={theme.spacing(2)}>{children}</Box>
    </Dialog>
  );
};
